import React, { useEffect, useState } from "react";

//redux
import { connect, useDispatch, useSelector } from "react-redux";

//MUI
import {
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Tooltip,
} from "@material-ui/core";
import { Cancel } from "@material-ui/icons";

//types
import { CLOSE_RESTRICTED_ACCOUNT_DIALOG } from "../../store/restrictedAccount/types";

//action
import { createRestrictedAccount } from "../../store/restrictedAccount/action";

import { permissionError } from "../../util/Alert";

const RestrictedAccountDialog = (props) => {
    const dispatch = useDispatch();

    const { dialog: open, dialogData } = useSelector((state) => state.restrictedAccount);
    const hasPermission = useSelector((state) => state.admin.admin.flag);

    const [uniqueId, setUniqueId] = useState("");
    const [reason, setReason] = useState("");

    const [errors, setError] = useState({
        uniqueId: "",
        reason: "",
    });

    useEffect(() => {
        if (dialogData) {
            setUniqueId(dialogData.uniqueId || "");
            setReason(dialogData.reason || "");
        }
    }, [dialogData]);

    useEffect(
        () => () => {
            setError({
                uniqueId: "",
                reason: "",
            });
            setUniqueId("");
            setReason("");
        },
        [open]
    );

    useEffect(() => {
        window.onbeforeunload = closePopup();
    }, []);

    const closePopup = () => {
        dispatch({ type: CLOSE_RESTRICTED_ACCOUNT_DIALOG });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!uniqueId) {
            const error = {};

            if (!uniqueId) error.uniqueId = "Unique ID is required!";

            return setError({ ...error });
        }

        // Basic validation for uniqueId
        if (uniqueId.trim().length === 0) {
            return setError({ ...errors, uniqueId: "Invalid Unique ID!!" });
        }

        const data = {
            uniqueId: uniqueId.trim(),
            reason: reason.trim(),
        };

        if (!hasPermission) return permissionError();
        props.createRestrictedAccount(data);
    };

    return (
        <>
            <Dialog
                open={open}
                aria-labelledby="responsive-dialog-title"
                onClose={closePopup}
                disableBackdropClick
                disableEscapeKeyDown
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle id="responsive-dialog-title">
                    <span className="text-danger font-weight-bold h4"> Create Restricted Account </span>
                </DialogTitle>

                <IconButton
                    style={{
                        position: "absolute",
                        right: 0,
                    }}
                >
                    <Tooltip title="Close">
                        <Cancel className="text-danger" onClick={closePopup} />
                    </Tooltip>
                </IconButton>
                <DialogContent>
                    <div className="modal-body pt-1 px-1 pb-3">
                        <div className="d-flex flex-column">
                            <form>
                                <div className="form-group">
                                    <label className="mb-2 text-gray">User Unique ID</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        required=""
                                        value={uniqueId}
                                        placeholder="Enter user's unique ID"
                                        onChange={(e) => {
                                            setUniqueId(e.target.value);
                                            if (!e.target.value) {
                                                return setError({
                                                    ...errors,
                                                    uniqueId: "Unique ID is Required !",
                                                });
                                            } else {
                                                return setError({
                                                    ...errors,
                                                    uniqueId: "",
                                                });
                                            }
                                        }}
                                    />
                                    {errors.uniqueId && (
                                        <div className="ml-2 mt-1">
                                            {errors.uniqueId && (
                                                <div className="pl-1 text__left">
                                                    <span className="text-red">{errors.uniqueId}</span>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                                <div className="form-group">
                                    <label className="mb-2 text-gray">Reason (Optional)</label>
                                    <textarea
                                        className="form-control"
                                        rows="3"
                                        value={reason}
                                        placeholder="Enter reason for restriction"
                                        onChange={(e) => {
                                            setReason(e.target.value);
                                        }}
                                    />
                                </div>
                                <div className="mt-5">
                                    <button
                                        type="button"
                                        className="btn btn-outline-info ml-2 btn-round float__right icon_margin"
                                        onClick={closePopup}
                                    >
                                        Close
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-round float__right btn-danger"
                                        onClick={handleSubmit}
                                    >
                                        Submit
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default connect(null, { createRestrictedAccount })(RestrictedAccountDialog);
